import { axios } from "../helpers/axios";
import { setNoAlertStatus } from "../helpers/storage";

export type UniqueStationPaload = {
  workstation_name: string;
};

// API for fetching inspection stations along with filters
export const getAllInspectionStation = (payload: any): Promise<any> => {
  setNoAlertStatus(true);
  return axios.get(
    `workstations/get_workstations/?status=${payload.status}&current=${payload.current}&limit_to=${payload.limit_to}&sort=${payload.sort}&station=${payload.station}`
  );
};
// API for fetching inspection stations along with station type filters
export const getAllInspectionStationWithType = (payload: any): Promise<any> => {
  setNoAlertStatus(true);
  return axios.get(
    `workstations/get_workstations_by_type/?workstation_type=${payload}`
  );
};

// API for deleting an inspection station
export const deleteInspectionStation = (id: string): Promise<any> => {
  return axios.delete(`workstations/delete_workstation/${id}`);
};

// API for duplicating inspection station
export const duplicateInspectionStation = (payload: any): Promise<any> => {
  return axios.post(`workstations/duplicate_workstation/`, payload);
};

// API for check unique station name
export const checkUniqueStationName = (
  payload: UniqueStationPaload
): Promise<any> => {
  setNoAlertStatus(true);
  return axios.post("workstations/check_unique_workstation_name/", payload, {
    suppressAlerts: { statusCode: [422] },
  } as any);
};

// API for creating new inspection station
export const createInspectionStation = (payload: any): Promise<any> => {
  return axios.post("workstations/add_workstation/", payload);
};

// API for changing inspection station status
export const changeStationstatus = (payload: any): Promise<any> => {
  return axios.get(`workstations/update_workstation_status/${payload}`);
};

// API for updating/editing inspection station
export const editInspectionStation = (payload: any): Promise<any> => {
  return axios.patch(`workstations/update_workstation/`, payload);
};

export const analyticsData = ({
  from_date,
  to_date,
  station_id,
}: any): Promise<any> => {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return axios.get(
    `analytics/get_statistics_for_workstations/?from_date=${from_date}&to_date=${to_date}${
      station_id ? `&workstation_id=${station_id}` : ""
    }&timezone=${encodeURIComponent(timezone)}`
  );
};

export const graphOneData = (payload: any): Promise<any> => {
  const { from_date, to_date, station_id, filter_type } = payload;
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return axios.get(
    `analytics/get_graph1_stats/?from_date=${from_date}&to_date=${to_date}${
      station_id ? `&workstation_id=${station_id}` : ""
    }${
      filter_type ? `&filter_type=${filter_type}` : ""
    }&timezone=${encodeURIComponent(timezone)}`
  );
};

//API for getting single workstation id
export const getWorkstationDetails = (id: any): Promise<any> => {
  return axios.get(`workstations/workstation/${id}`);
};

export const getWorkstationInfo = (workstation_id: any): Promise<any> => {
  return axios.get(
    `workstations/get_workstation_info/?workstation_id=${workstation_id}`
  );
};


// API for cloning an inspection station
export const cloneInspectionStation = (payload: any): Promise<any> => {
  return axios.post(`workstations/duplicate_workstation/`, payload);
};